import React from 'react';
import useGTM from '@elgorditosalsero/react-gtm-hook';

import { DEVELOPMENT_GTM_ID, PRODUCTION_GTM_ID } from '../Constants';

const EVENT = 'demoEventAiAutomation';

type KeyToSuccessCategory = 'Global operation' | 'Access to data' | 'Competence & innovation';

/**
 * Hook for communicating with the Ericsson GTM container
 */
export const useEricssonGTM = () => {
  const { init, sendDataToGTM } = useGTM();

  /**
   * Should be called at app startup to initialize the GTM container
   */
  const InitCallback = React.useCallback(() => {
    const gtmId = process.env.NODE_ENV === 'development' ? DEVELOPMENT_GTM_ID : PRODUCTION_GTM_ID;

    init({ id: gtmId, dataLayer: {} });
  }, [init]);

  /**
   * Should be called when the 'Start Journey' button clicked by the user on the Home screen
   */
  const StartJourneyClickCallback = React.useCallback(() => {
    const eventArgs = {
      event: EVENT,
      demoEventAction: 'Start Journey',
    };

    sendDataToGTM(eventArgs);
  }, [sendDataToGTM]);

  /**
   * Should be call on every journey step (slide) change
   * @param step The journey step (not index!)
   */
  const OnNewJourneyStepCallback = React.useCallback(
    (step: number) => {
      const eventArgs = {
        event: EVENT,
        demoEventAction: `${step}`,
      };

      sendDataToGTM(eventArgs);
    },
    [sendDataToGTM]
  );

  /**
   * Should be called when a category is click on the Key to success screen
   * @param category The category that has been clicked
   */
  const OnKeyToSuccessCategoryClickCallback = React.useCallback(
    (category: KeyToSuccessCategory) => {
      const eventArgs = {
        event: EVENT,
        demoEventAction: 'Key Category Click',
        demoEventLabel: `${category}`,
      };

      sendDataToGTM(eventArgs);
    },
    [sendDataToGTM]
  );

  return {
    init: InitCallback,
    onStartJourneyClick: StartJourneyClickCallback,
    onNewJourneyStep: OnNewJourneyStepCallback,
    onKeyToSuccessCategoryClick: OnKeyToSuccessCategoryClickCallback,
  };
};
